import React, { createContext, useContext } from 'react'

interface BreakEditContextValue {
  getBreakDragStart: (techId: string) => (e: React.MouseEvent) => void
}

const BreakEditContext = createContext<BreakEditContextValue | null>(null)

export const BreakEditProvider = BreakEditContext.Provider

export function useBreakEditContext(): BreakEditContextValue {
  const ctx = useContext(BreakEditContext)
  if (!ctx) throw new Error('useBreakEditContext must be used inside BreakEditProvider')
  return ctx
}
